import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {
  setVehicleFilter,
  toggleShowAllTrips,
} from '../../actions/trip';
import { withTranslation } from 'react-i18next';

class VehicleFilter extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(name) {
    const { setVehicleFilter, toggleShowAllTrips, showAllTrips } = this.props;
    setVehicleFilter(name);
    if(!showAllTrips) {
      toggleShowAllTrips(true);
    }
  }

  render() {
    const { vehicleFilter, name, desc, image, t } = this.props;
    return (
      <div className={`fe-vehicle-filter ${name === vehicleFilter ? 'checked' : ''}`}>
        <div
          className="fe-vehicle-filter-img"
          onClick={() => this.handleClick(name)}
        >
          <div className="fe-u-thumb-3by1">
            <img src={image} alt=""/>
          </div>
        </div>
        <div className="fe-vehicle-filter-name">{ name === 'All vehicles' ? t('home:allVehicles') : name }</div>
        <div className="fe-vehicle-filter-desc">{ desc }</div>
      </div>
    );
  }
}

VehicleFilter.propTypes = {
  name: PropTypes.string.isRequired,
  desc: PropTypes.string,
  vehicleFilter: PropTypes.string.isRequired,
  setVehicleFilter: PropTypes.func.isRequired,
  toggleShowAllTrips: PropTypes.func.isRequired,
  showAllTrips: PropTypes.bool.isRequired,
  image: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ tripState }) => ({
  vehicleFilter: tripState.vehicleFilter,
  showAllTrips: tripState.showAllTrips,
});

const mapDispatchToProps = {
  setVehicleFilter,
  toggleShowAllTrips,
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VehicleFilter));
